/**
 * Employee Name Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.employeeNameFormatter = function(value, row) {
    if (rights.includes("employees.show") === 1 && value) {
        return '<a href="/employees/show/'+row.user_id+'">'+value+'</a>';
    } else if (value) {
        return value;
    }
};
